import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from '@/hooks/useTranslation';
const MentionsLegales: React.FC = () => {
  const { t } = useTranslation();
  return <div className="min-h-screen bg-background">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="mb-8">
          <Button asChild variant="ghost" className="mb-6">
            <Link to="/" className="flex items-center">
              <ArrowLeft className="w-4 h-4 mr-2" />
              {t('backToHome')}
            </Link>
          </Button>
          
          <h1 className="text-3xl font-bold text-foreground mb-8">{t('legalNoticeTitle')}</h1>
        </div>

        <div className="space-y-8 text-muted-foreground">
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-4">1. Éditeur du Site</h2>
            <p className="leading-relaxed">
              Le présent site web est édité par :
            </p>
            <ul className="mt-4 space-y-2 ml-4">
              <li><strong>Nom de l'entreprise :</strong> DiskOver</li>
              <li><strong>Représentant légal :</strong> François P.</li>
              <li><strong>Adresse e-mail :</strong> francoisp02@berkeley.edu</li>
            </ul>
            
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-4">2. Hébergeur du Site</h2>
            <p className="leading-relaxed">
              Le site DiskOver est hébergé par :
            </p>
            <ul className="mt-4 space-y-2 ml-4">
              <li><strong>Google Cloud Platform</strong></li>
              <li><strong>Adresse :</strong> Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA</li>
              <li><strong>Site web :</strong> <a href="https://cloud.google.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://cloud.google.com/</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-4">3. Propriété Intellectuelle</h2>
            <p className="leading-relaxed">
              L'ensemble du contenu de ce site est la propriété exclusive de DiskOver ou de François P., sauf mention contraire.
            </p>
            <p className="mt-4 leading-relaxed">
              Toute reproduction ou utilisation non autorisée est interdite.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-4">4. {t('personalDataProtection')}</h2>
            <p className="leading-relaxed">
              {t('diskoverCommitment')}
            </p>
            <p className="mt-4 leading-relaxed">
              Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition à vos données. Contactez-nous à l'adresse e-mail indiquée.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-4">5. Droit Applicable et Attribution de Juridiction</h2>
            <p className="leading-relaxed">
              Tout litige en relation avec l'utilisation du site DiskOver est soumis au droit français.
            </p>
            <p className="mt-4 leading-relaxed">
              En cas de litige, les tribunaux français seront seuls compétents.
            </p>
          </section>
        </div>
      </div>
    </div>;
};
export default MentionsLegales;